import { render } from "./PanelFacturacionView.vue?vue&type=template&id=087749ec"
import script from "./PanelFacturacionView.vue?vue&type=script&lang=js"
export * from "./PanelFacturacionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__